import {BaseModel} from '../base.model';
import {JsonProperty} from '../json-map.util';
import {SolutionModel} from '../solution/solution.model';
import {ProblemModel} from '../problem/problem.model';

class PassageModel extends BaseModel {

  title: string = undefined as any;
  content: string = undefined as any;
  @JsonProperty({ clazz: ProblemModel })
  problems: ProblemModel[] = [];

}


export { PassageModel };
